
import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'base',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '/', component: () => import('pages/InsightList.vue'), name: 'insight-list' },
      // { path: '/', component: () => import('pages/SnapList.vue'), name: 'snap-list' },
      { path: '/orders/', component: () => import('pages/OrderList.vue'), name: 'order-list' },
      { path: '/strategies/', component: () => import('pages/StrategyList.vue'), name: 'strategy-list' },
      { path: '/logs/', component: () => import('pages/LogList.vue'), name: 'logs' },
      { path: '/trades/', component: () => import('pages/TradeList.vue'), name: 'trade-list' },
      { path: '/trends/:symbol/', component: () => import('pages/Trend.vue'), name: 'trend' },
      { path: '/insights/:symbol/', component: () => import('pages/InsightDetail.vue'), name: 'insight-detail' },
      { path: '/scrips/', component: () => import('pages/ScripList.vue'), name: 'scrip-list' },
      { path: '/snapshot/', component: () => import('pages/SnapList.vue'), name: 'snap-list' },
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/login/',
    name: 'login',
    meta: { auth: true },
    component: ()=> import('pages/Login.vue')
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue'),
  },
];

export default routes;
